exports.addInlineError = function (container, button, errorId, errorPhrase, errorMessage) {
    let span = document.getElementById(errorId);
    if (span && span.lastChild) {
        span.lastChild.textContent = errorMessage;
    } else {
        span = document.createElement("span");
        span.id = errorId;
        span.className = "govuk-error-message";
        const hiddenSpan = span.appendChild(document.createElement("span"));
        hiddenSpan.className = "govuk-visually-hidden";
        hiddenSpan.textContent = `${errorPhrase}:`;
        const errorSpan = span.appendChild(document.createElement("span"));
        errorSpan.textContent = errorMessage;
    }
    container.insertBefore(span, button);
    container.classList.add("govuk-form-group--error");
};

exports.addErrorSummaryItem = function (errorList, fieldId, errorMessage, itemId) {
    const listItem = document.createElement("li");
    if (itemId) listItem.id = itemId;
    const anchor = listItem.appendChild(document.createElement("a"));
    anchor.href = "#" + fieldId;
    anchor.textContent = errorMessage;
    errorList.appendChild(listItem);
};

exports.updateTitleIfNotAlreadyInError = function (errorPhrase) {
    const title = document.title;
    if (!title.startsWith(`${errorPhrase}:`)) {
        document.title = `${errorPhrase}: ${title}`;
    }
};
